import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import StartersForm from "@/components/StartersForm";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useAuth } from "@/auth/AuthContext";
import { EMPTY_STARTERS } from "@/lib/starters";
import { useTranslation } from "@/i18n";
import { toast } from "sonner";

export default function Starters() {
  const { t } = useTranslation();
  const { user, saveStarters, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const submit = async (value) => {
    setBusy(true);
    try {
      await saveStarters(value);
      toast.success(t("starters.saved"));
      navigate("/", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background transition-colors duration-300 flex flex-col">
      <header className="sticky top-0 z-20 backdrop-blur-xl bg-card/80 border-b border-border">
        <div className="mx-auto max-w-2xl px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded-lg bg-slate-900 flex items-center justify-center">
              <Clock className="h-3.5 w-3.5 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-display text-base font-semibold tracking-tight text-slate-900">Chronicles</span>
          </div>
          <LanguageSwitcher />
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-2xl px-5 py-8">
        <p className="text-[11px] uppercase tracking-[0.24em] text-slate-500 mb-2">{t("starters.title")}</p>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">
          {user?.alias ? t("starters.greeting", { alias: user.alias }) : t("starters.title")}
        </h1>
        <p className="mt-2 text-sm text-slate-600 max-w-lg">{t("starters.intro")}</p>

        <div className="mt-8">
          <StartersForm
            initial={EMPTY_STARTERS}
            onSubmit={submit}
            submitLabel={t("starters.finish")}
            busy={busy}
          />
        </div>
      </main>
    </div>
  );
}
